import Enps from './Enps'
import Report from './report'
import Duplicate from './duplicate'
import { NewEnpsResearch, EditEnpsResearch, AppliedModal } from './children'

export default Enps
export { NewEnpsResearch, EditEnpsResearch, AppliedModal, Report, Duplicate }
